/**
 * Angular JS Common Controller
 *
 * @category Controllers
 * @package Common
 * @author Chris <chriswelland@yellostudio.co.uk>
 * @copyright (c) 2016, Yello Studio
 * @version 0.1
 */

(function(){

    'use strict';

    var NewsController = function($scope, $http, $timeout){

        var _this = this;

        $scope.articles = [];

        // Construct the NewsController
        this.construct = function(){
            _this.getNews();
        };

        this.setEqualHeights = function(){
            // $('section .w-33').height('auto');
            // $('section .w-33 .padd').height('auto');
            // var max33 = 0;
                  // $('section .w-33').each(function(){
                  // 	var h = $(this).height();
                  // 	if(h > max33){ max33 = h; }
                  // });
            //
            // $('section .w-33').height(max33);
            // $('section .w-33 .padd').height(max33 - 300);
            //
            // $('section .w-50').height('auto');
            // var max50 = 0;
                  // $('section .w-50').each(function(){
                  // 	var h = $(this).height();
                  // 	if(h > max50){ max50 = h; }
                  // });
            //
              //  $('section .w-50').height(max50);
        };

        // Process the Ajax login request.
        this.getNews = function() {
            $http({
                url:'/api/news',
                type:'GET',
                params: {
                    locale: window.Craft.locale
                }
            }).then(function(response){
                    if(response.error){
                        console.log("ERROR: unable to retrieve news");
                    } else {
                      /*
                      $scope.featuredArticle = response.articles[0];
                      response.articles.shift();
                      $scope.articles = response.articles;
                      */

                      $scope.articles = response.data.articles;
                      $timeout(function(){
                        _this.setEqualHeights();
                      });
                    }
                }, function(response){
                    console.log("ERROR: Endpoint not functioning");
                });
        };

        $(window).on('resize', function(){
            _this.setEqualHeights();
        });

        $scope.$watch('searchtext', function(){
            $timeout(function(){
                _this.setEqualHeights();
            });

        }, true);

        $scope.$watch('cat', function(){
            $timeout(function(){
                _this.setEqualHeights();
            });

        }, true);

        this.construct.apply(this, arguments);

    };

    angular.module('App').controller('NewsController', NewsController);

})();
